//global.js edited , commented line no. 532, 536
$(document).ready(function(){
  $('#product-media-modal__content').slick({
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<div class="slick-prev"><i class="fa-solid fa-circle-chevron-left"></i></div>',
    nextArrow: '<div class="slick-next"><i class="fa-solid fa-circle-chevron-right"></i></div>'
  });
  $('.form-slick-slider').slick({
    arrows: true,
    dots:true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<div class="slick-prev"><i class="fa fa-arrow-left"></i> BACK</div>',
    nextArrow: '<div class="slick-next">NEXT <i class="fa fa-arrow-right"></i></div>'
  });
})

				